export default {
    downtimeUrl: "https://cl.kodland.tech",
    startPage: {
      startBackground: "#E4FF9C",
      quizBackground: "#white",
      title: '<div align="center"><b>5 soruyu yanıtlayın ve çocuğunuz için ÜCRETSİZ ders alın</div></b>',
      image: {
        url:  "/welcome/quiz_turkey_steps_bonus_page_pk.png",
        style: {
          height: "100%",
          "max-height": "100vh",
        },
      },
      button: {
        text: "  Ders alın 🚀  ",
        style: {
          background: "#FFFFFF",
          color: "#18182E",
          "font-weight": "bold",
        },
      },
      imageMobile: {
        url: "/welcome/quiz_turkey_steps_bonus_page_mobile.png",
        style: {
          width: "100%",
        },
      },
    },
    quizRotateBySteps: {
      1: {
        stopNew: true,
        question: "Çocuğunuzu cezbedici bilgisayar bilimlerinde ücretsiz bir derse kaydedin",
        answers: [
            {
              answer: "Ben bir ebeveynim",
              event_name: "parent",
              event_source: "google"
            },
            {
              answer: "Ben 13-17 yaş aralığında bir çocuğum",
              stopAnswer: true,
              event_name: "child",
              event_source: "google"
            },
        ],
        stopPage: {
            image: "/welcome/quiz_stop_page.jpg",
            title: 'Maalesef, sınıfımıza katılmak için veli katılımı zorunludur. Ücretsiz bir sınıf rezervasyonu yapmak için<p> <a href="https://www.kodland.org/welcome/quiz/turkey_parent_or_child?segment=31&date_start=0&date_end=6%3Futm_source%3Dgoogle&utm_medium=cpc&utm_campaign={campaignid}&utm_term={keyword}&utm_content={creative}">aşağıdaki bağlantıyı<a> <p>ebeveyninize gönderin, sınıflarımızda sizi bekliyor olacağız!',
        },
      },
      2: {
        question: "Çocuğunuz genellikle boş zamanlarını nasıl geçirir?",
        answers: [
          "🎮 Cep telefonu ve bilgisayarda oyun oynar",
          "🎨 Sanatsal faaliyetlerde bulunur: çizim, müzik, oyunculuk",
          "⚽️ Spor yapar",
          "🏕️ Ailesiyle vakit geçirir",
          "👀 Çizgi film izler",
          "🤝 Arkadaşlarıyla sosyalleşir",
        ],
      },
      3: {
        question: "Çocuğunuzun okulda en sevdiği ders hangisidir?",
        answers: [
          "🔬 Fen bilimleri",
          "🎨 Sanat ve tasarım",
          "💻 Bilgisayar bilimi",
          "📙 Tarih, Edebiyat",
          "📐 Matematik",
          "💬 Yabancı diller",
          "🤩 Tüm dersler",
          "🤔 Emin değilim",
        ],
      },
      4: {
        title: "Deneme dersi için hangi saatte uygunsunuz?",
        type: "timeslot",
        subtitle:
          "Özel dersinizi rezerve etmek için birkaç adım kaldı! Sizinle tanışmak için sabırsızlanıyoruz🥳",
        button: "Rezervasyon için tıklayın 🎁",
      },
      5: {
        question: "Çocuğunuzun herhangi bir bilgisayar becerisi var mı?",
        answers: [
          "😌 Evet, Microsoft Word/PowerPoint",
          "🖥 Evet, temel kodlama",
          "👍 Evet, oyun oynamayı sever (Roblox, Minecraft)",
          "🤔 Hayır",
        ],
      },
      6: {
        stopNew: true,
        question: "Çalışabileceğiniz bir masaüstü/dizüstü bilgisayarınız var mı?",
        answers: [
          {
            answer: "💻 Evet",
            distribution_tag_question: [18],
          },
          {
            answer: "😐 Hayır",
            stopAnswer: true,
          },
        ],
        stopPage: {
          image: "/welcome/quiz_stop_page.jpg",
          title:
            "Eğitim platformumuza güvendiğiniz için teşekkür ederiz! Maalesef tabletler veya telefonlar derslerimizi almak için uygun değil. Bir dahaki sefere sizi sınıflarımızda görmekten mutluluk duyarız!",
        },
      },
      7: {
        title: "Çocuğunuz kaç yaşında?",
        type: "age",
        subtitle: "Çocuğunuzun yaşına göre en eğlenceli kursu seçeceğiz",
        button: "İleri 🚀",
      },
      8: {
        title: "Çocuğunuzun adı nedir?",
        type: "child_name",
        subtitle: "Veriler korunmaktadır ve talebiniz üzerine silinecektir 🚨",
        button: "İleri 🚀",
      },
      9: {
        title: "E-postanızı girin",
        type: "mail",
        subtitle: "Endişelenmeyin, spam gönderilmeyecek😅",
        button: "İleri 🚀",
      },
      10: {
        title: "Telefon numaranızı girin",
        type: "phone",
        subtitle: "Önemli konularda sizinle iletişime geçmek için kullanacağız 📞",
        button: "Neredeyse bitti 🔥",
      },
      11: {
        title: "İsminizi girin",
        type: "parent_name",
        subtitle: "Bizim adımız Kodland, sizinki ne?👋",
        button: "Son adım! 🎉",
      },
    },
  };
  